





































































import { PropType } from 'vue';
import { defineComponent, toRefs, computed, ref, nextTick } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, AdgroupConfig, EMEventType, IOS14Type } from '@tt4b/ttam-enums';
import AppEvent from './index';
import AttributionTips from '@/components/adgroup/attribution-tips/index.vue';
import BackgroundConatiner from '@/components/common/background-container/index.vue';
import {
  StateEnum,
  useAllowlist,
  useAppInfo,
  useStdAdgroupIs,
  useStore,
  useAdgroupAppEventValidate,
} from '@tt4b/ttam-hooks';
import { useSelectedApp } from './../../../hooks/creation/adgroup/useSelectedApp/index';

const name = 'ttam-app-event-compose';
export default defineComponent({
  name,
  components: {
    TtamAttributionTips: AttributionTips,
    TtamAppEventExternalActionSelect: AppEvent.TtamAppEventExternalActionSelect,
    TtamAppEventAllEventsInactiveTips: AppEvent.TtamAppEventAllEventsInactiveTips,
    TtamAppEventCboExternalActionNotSupportTips: AppEvent.TtamCboExternalActionNotSupportTips,
    TtamAppEventDeepAppEventLabel: AppEvent.TtamAppEventDeepAppEventLabel,
    TtamAppEventDeepAppEventLabelHint: AppEvent.TtamAppEventDeepAppEventLabelHint,
    TtamAppEventInAppEventLabel: AppEvent.TtamAppEventInAppEventLabel,
    TtamAppEventInAppEventLabelHint: AppEvent.TtamAppEventInAppEventLabelHint,
    TtamAppEventTiktokWarningTips: AppEvent.TtamAppEventTiktokWarningTips,
    TtamBackgroundConatiner: BackgroundConatiner,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig } = toRefs(props);
    const inAppEventRef = ref();
    const deepAppEventRef = ref();
    const { selectedAppObj: appInfo } = useSelectedApp({
      adgroupData,
    });

    const { isStandardAdsWithCatalog, isProductRetargeting } = useStdAdgroupIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    /** Get Data From Store  */
    const { state, getStore } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);
    const { data: appEvents } = getStore(StateEnum.appEvents, {
      isRetargeting: isStandardAdsWithCatalog.value ? isProductRetargeting.value : undefined,
      objectiveType: campaignData.value.objectiveType,
      appId: adgroupData.value.adRefAppId,
      optimizeGoal: adgroupData.value.optimizeGoal,
      inventoryFlow: adgroupData.value.inventoryFlow,
      isDC: adgroupData.value.targetDeviceVersion === IOS14Type.ABOVE,
    });

    /** 组件逻辑  */
    const _externalAction = computed({
      get: () => (props.adgroupData?.externalAction === EMEventType.NO_ACTIVE ? '' : props.adgroupData?.externalAction),
      set: val => {
        emit('external-action-change', val);
        nextTick(() => {
          inAppEventRef.value?.validate?.();
        });
      },
    });

    const _deepExternalAction = computed({
      get: () =>
        props.adgroupData?.deepExternalAction === EMEventType.NO_ACTIVE ? '' : props.adgroupData?.deepExternalAction,
      set: val => {
        emit('deep-external-action-change', val);
        nextTick(() => {
          deepAppEventRef.value?.validate?.();
        });
      },
    });

    const { visible: tiktokWarningTipsVisible } = AppEvent.useTiktokWarningTipsPropsVisible({
      adgroupData,
      campaignData,
    });

    const { visible: allEventsInactiveTipsVisible } = AppEvent.useAllEventsInactiveTipsPropsVisible({
      appEvents,
      adgroupData,
      campaignData,
    });
    const { visible: eaNotSupportTipsVisible } = AppEvent.useEANotSupportTipsPropsVisible({
      appEvents,
      adgroupData,
      campaignData,
      externalAction: _externalAction,
    });

    const { disabled: deepEventDisabled } = AppEvent.useExternalActionSelectPropsDisabled({
      adgroupConfig,
      type: 'deep-event',
      adgroupData,
      campaignData,
    });

    const { disabled: inEventDisabled } = AppEvent.useExternalActionSelectPropsDisabled({
      adgroupConfig,
      type: 'in-event',
      adgroupData,
      campaignData,
    });

    const { options: deepEventOptions } = AppEvent.useExternalActionSelectPropsOptions({
      adgroupData,
      appEvents,
      type: 'deep-event',
      campaignData,
    });

    const { options: inEventOptions } = AppEvent.useExternalActionSelectPropsOptions({
      adgroupData,
      campaignData,
      appEvents,
      type: 'in-event',
      externalAction: _externalAction,
    });

    const { isCboAeo } = AppEvent.useExternalActionSelectPropsisCboAeo({
      adgroupData,
      campaignData,
    });

    const { inAppEventValidator, installWithInAppEventValidator } = useAdgroupAppEventValidate();

    const { visible, inAppEventVisible, deepAppEventVisible } = AppEvent.usePropsVisible({
      adgroupData,
      campaignData,
      appEvents,
    });

    return {
      name,
      _externalAction,
      _deepExternalAction,
      inAppEventValidator,
      installWithInAppEventValidator,
      tiktokWarningTipsVisible,
      allEventsInactiveTipsVisible,
      eaNotSupportTipsVisible,
      deepEventDisabled,
      deepEventOptions,
      inEventDisabled,
      inEventOptions,
      aadvid,
      appId4EM: useAppInfo({
        appInfo,
      })?.appId4EM,
      isCboAeo,
      isHasTTPWhite: useAllowlist()?.isHasTTPWhite,
      visible,
      inAppEventVisible,
      deepAppEventVisible,
      inAppEventRef,
      deepAppEventRef,
    };
  },
});
